import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import SlotDefinition from "slotworks/model/slot-definition";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";
import * as TweenJS from "slotworks/utils/tween";

export default class LandPulseSymbolBehaviour extends AbstractSymbolBehaviour {

    private scale: number;

    public land(): Contract<void> {
        return new Contract<void>((resolve) => {
            if (SlotDefinition.getSymbolDefinition(this.symbol.symbolId).bonusId) {

                this.scale = 1;

                const growTween = new TweenJS.Tween(this)
                    .to({ scale: 1.1 }, 100)
                    .onUpdate(() => this.update());

                const shrinkTween = new TweenJS.Tween(this)
                    .to({ scale: 1 }, 100)
                    .onUpdate(() => this.update());

                growTween.chain(shrinkTween);
                shrinkTween.onComplete(resolve);

                growTween.start();
            }
        });
    }

    private update() {
        this.symbol.setScale(new Point(this.scale, this.scale));
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/land-pulse-symbol-behaviour.ts